import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useContent } from "../context/ContentContext";
import { Link as ScrollLink } from "react-scroll";

export default function HeroSlider() {
  const content = useContent();
  const slides = content.getHeroSlides();
  let sliderRef = React.useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    swipe: true,
  };
  slides.forEach((slide) => {
    console.log(`Slides: ../data/images/${slide.image}`);
  });
  return (
    <Box
      id="hero"
      sx={{
        width: "100%",
        mt: "0px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "70vh",
          position: "relative",
        }}
      >
        <Slider ref={(c) => (sliderRef = c)} {...settings}>
          {slides.map((slide, i) => (
            <Box
              key={i}
              sx={{
                width: "100%",
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <img
                src={slide.image}
                alt={`slide-${i}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "fill",
                }}
              />

              {/* Overlayed content */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 32,
                  left: 32,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  zIndex: 2,
                  maxWidth: { xs: "90%", sm: "60%", md: "40%" },
                  width: "100%", // makes button alignment possible
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textShadow: "2px 2px 8px rgba(0,0,0,0.8)",
                    mb: 1,
                  }}
                >
                  {slide.title}
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "white",
                    textShadow: "1px 1px 6px rgba(0,0,0,0.7)",
                    mb: 2,
                    whiteSpace: "pre-line",
                  }}
                >
                  {slide.subtitle}
                </Typography>
                
                {/* Button aligned right */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", width: "200%" }}>
                  <ScrollLink to="contact" smooth duration={500} offset={-70}>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      //sx={{ px: 4, py: 1 }}
                    >
                      Contact Us
                    </Button>
                  </ScrollLink>
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>

        {/* Navigation arrows */}
        <IconButton
          onClick={() => sliderRef.slickPrev()}
          sx={{
            position: "absolute",
            top: "50%",
            left: "20px",
            transform: "translateY(-50%)",
            color: "white",
            bgcolor: "rgba(0,0,0,0.4)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
            zIndex: 2,
          }}
        >
          <ArrowBackIos />
        </IconButton>

        <IconButton
          onClick={() => sliderRef.slickNext()}
          sx={{
            position: "absolute",
            top: "50%",
            right: "20px",
            transform: "translateY(-50%)",
            color: "white",
            bgcolor: "rgba(0,0,0,0.4)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
            zIndex: 2,
          }}
        >
          <ArrowForwardIos />
        </IconButton>
      </Box>
    </Box>
  );
}
